import { Component } from '@theme/component';

/**
 * Tab bar inside the PDP size-guide popup, switching between the "Tabela de
 * medidas" and "Como medir" images. Both panels are server-rendered up
 * front; switching only toggles which one is visible.
 *
 * @typedef {Object} Refs
 * @property {HTMLButtonElement[]} tabs
 * @property {HTMLElement[]} panels
 *
 * @extends {Component<Refs>}
 */
class PdpSizeGuideTabsComponent extends Component {
  requiredRefs = ['tabs', 'panels'];

  /**
   * @param {number} tabIndex - The index of the tab to select.
   */
  selectTab(tabIndex) {
    const { tabs, panels } = this.refs;
    const index = String(tabIndex);

    tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', String(tab.dataset.tabIndex === index));
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabIndex !== index;
    });
  }
}

if (!customElements.get('pdp-size-guide-tabs')) {
  customElements.define('pdp-size-guide-tabs', PdpSizeGuideTabsComponent);
}
